import {
  Button,
  Card,
  CardContent,
} from "@/components/ui";
import { BadgeDollarSign, ChevronRight, ReceiptText, TriangleAlert } from "lucide-react";
import { FormSectionHeader, Loader } from "@/components";
import useCriticalActionSection from "./useCriticalActionSection";
import { cn } from "@/lib/utils";

const CriticalActionSection = () => {
  const {
    onInvoiceAwaitingClick,
    isParkedStatus,
    isOpenIncidentLoading,
    onViewIncident,
    isExpenseIncomeDataLoading,
    onOverdueClick,
    awaitingApproval,
    incidentCount,
    overdueCount
  } = useCriticalActionSection();

  return (
    <Card className="shadow-none">
      <CardContent>
        <FormSectionHeader className="text-[18px] font-[500] flex flex-row items-center gap-2 text-primary">
          <TriangleAlert className="h-6 w-6 stroke-2" /> ATTENTION REQUIRED
        </FormSectionHeader>
        {isParkedStatus || isOpenIncidentLoading || isExpenseIncomeDataLoading? (
          <Loader />
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[10px]">
              <Card className={cn("shadow-none", awaitingApproval ? "bg-red-50" : "bg-green-50")}>
                <CardContent className="flex flex-row gap-3">
                  <div className={cn("h-12 w-12 flex items-center justify-center rounded-full", awaitingApproval ? "bg-red-600" : "bg-green-600")}>
                    <ReceiptText className="stroke-white h-7 "/>
                  </div>
                  <div className="flex flex-col">
                    <span className={cn("text-red-600 text-[24px] font-semibold", awaitingApproval ? "text-red-600" : "text-black-600")}>{awaitingApproval}</span>
                    <span className="text-[14px] text-gray-700 font-medium">Invoices Awaiting Approval</span>
                    {awaitingApproval ? <Button variant="ghost" className={cn("w-[135px] hover:bg-transparent hover:font-semibold transition-all", awaitingApproval ? "text-red-600 hover:text-red-600" : "text-black-600 hover:text-black-600")} onClick={onInvoiceAwaitingClick}>
                      Action Required <ChevronRight className="stroke-3" />
                    </Button> : <></>}
                  </div>
                </CardContent>
              </Card>
              <Card className={cn("shadow-none", incidentCount ? "bg-red-50" : "bg-violet-50")}>
                <CardContent className="flex flex-row gap-3">
                  <div className={cn("h-12 w-12 flex items-center justify-center rounded-full", incidentCount ? "bg-red-600" : "bg-violet-600")}>
                    <TriangleAlert className="stroke-white h-7 "/>
                  </div>
                  <div className="flex flex-col">
                    <span className={cn("text-[24px] font-semibold", incidentCount ? "text-red-600" : "text-violet-600")}>
                      {incidentCount}
                    </span>
                    <span className="text-[14px] text-gray-700 font-medium">Open Incidents</span>
                    {incidentCount ? <Button variant="ghost" className={cn("w-[135px] hover:bg-transparent hover:font-semibold transition-all", incidentCount ? "text-red-600 hover:text-red-600" : "text-black-600 hover:text-black-600")} onClick={onViewIncident}>
                      Action Required <ChevronRight className="stroke-3" />
                    </Button> : <></>}
                  </div>
                </CardContent>
              </Card>
              <Card className={cn("shadow-none", overdueCount ? "bg-red-50" : "bg-amber-50")}>
                <CardContent className="flex flex-row gap-3">
                  <div className={cn("bg-red-600 h-12 w-12 flex items-center justify-center rounded-full", overdueCount ? "bg-red-600" : "bg-amber-600")}>
                    <BadgeDollarSign className="stroke-white h-7 "/>
                  </div>
                  <div className="flex flex-col">
                    <span className={cn("text-[24px] font-semibold", overdueCount ? "text-red-600" : "text-black-600")}>{overdueCount}</span>
                    <span className="text-[14px] text-gray-700 font-medium">Overdue Invoices</span>
                    {overdueCount ? <Button variant="ghost" className="text-red-600 w-[135px] hover:text-red-600 hover:bg-transparent hover:font-semibold transition-all" onClick={onOverdueClick}>
                      Action Required <ChevronRight className="stroke-3" />
                    </Button> : <></>}
                  </div>
                </CardContent>
              </Card>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default CriticalActionSection;
